import { space } from "@smartsheet/design-tokens";
import { sizes } from "../../../constants/spacing";

// a ScrollAreaGutter that resolves to a single CSS length value (as opposed to a shorthand value)

var isLodestarSizeKey = function isLodestarSizeKey(key) {
  return key in sizes;
};
var isUrsaSpaceKey = function isUrsaSpaceKey(key) {
  return key in space;
};

// map a SingleLengthGutter to one CSS length string
// this assumes Lodestar and Ursa constant names remain mutually exclusive
export var resolveGutterLength = function resolveGutterLength(gutter) {
  if (isLodestarSizeKey(gutter)) {
    return "".concat(sizes[gutter], "px");
  }
  if (isUrsaSpaceKey(gutter)) {
    return space[gutter];
  }
  return "0px";
};
//# sourceMappingURL=resolveGutterLength.js.map